import { CTABlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/ctaBlock/ctaBlock.layout'
import { BackgroundColor } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/blocks.state'
import * as React from 'react'
import { StyleguideExample, StyleguidePart } from '../../../../../../Shared/Hoppinger.Styleguide/Frontend'
import { dummyData, randomTitle } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsCTABlock = () => (
  <>
    <StyleguidePart title="Orange" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentCTABlock bgColor="orange" />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Green" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentCTABlock bgColor="green" />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentCTABlock = (props: { bgColor: BackgroundColor }) => (
  <CTABlockLayout
    id="cta-block-example"
    title={randomTitle()}
    intro={dummyData.intro}
    primaryUpdater={dummyData.primaryUpdater}
    secondaryUpdater={dummyData.secondaryUpdater}
    bgColour={props.bgColor}
  />
)
